import { PublicClientApplication } from '@azure/msal-browser'
import config from 'src/config/config'

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: config.AUTH_APP_ID,
    authority: config.AUTHORITY,
    redirectUri: config.AUTH_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
})

export const loginRequest = {
  scopes: ['user.read', 'offline_access', 'openid', 'email', 'profile'],
}
